import React, { useEffect, useState } from "react";
import { Button, Modal, ProgressBar } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";

export default function FileUploadAutoPreview(props) {
  const { autoUpload, setAutoUpload, fileDrop, userDetail, selectedRow } =
    props;
  const [progress, setProgress] = useState([]);
  const [ready, setReady] = useState(false);

  const handleClose = () => {
    if (autoUpload.action) {
      autoUpload.action();
    } else {
      setAutoUpload({ show: false });
    }
  };

  useEffect(() => {
    if (fileDrop != null) {
      if (fileDrop) {
        let array = [];
        for (let index = 0; index < fileDrop.length; index++) {
          array.push(0);
        }
        setProgress(array);
        setReady(true);
      }
    }
  }, [fileDrop]);

  useEffect(() => {
    // console.log(progress);
  }, [progress]);

  useEffect(() => {
    if (ready) {
      console.log("ready to go");
      handleUpload();
    }
  }, [ready]);

  // handle upload all files and progress bar
  const handleUpload = async (evt) => {
    const url = process.env.REACT_APP_API + "api/studyinfo/upload-file-blob";

    for (let i = 0; i < fileDrop.length; i++) {
      const f = fileDrop[i];
      const formData = new FormData();
      formData.append("user", JSON.stringify({ ...userDetail, uploadType: 1 })); // uploadType(1=file, 2=captured image, 3=scanned image)
      formData.append("rowdata", JSON.stringify(selectedRow));
      formData.append("file", f);

      let result = await axios.post(url, formData, {
        headers: {
          ...HttpJsonHeader,
          "Content-Type": "multipath/form-data",
        },
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        timeout: 0,
        onUploadProgress: (evt) => {
          let numProgress = Math.round((100 * evt.loaded) / evt.total);
          for (let j = 0; j < progress.length; j++) {
            if (j === i) {
              progress[i] = numProgress;
            }
          }
          setProgress((p) => [...progress]);
        },
      });

      //debug
      if (result) {
        console.log("The file has been uploaded...");
      }
    }
    setReady(false);
    handleClose();
  };

  return (
    <MyModal
      show={autoUpload?.show}
      centered
      backdrop={false}
      onHide={handleClose}
    >
      <ModalHeaderBlack></ModalHeaderBlack>
      <ModalBodyBlack>
        <div
          style={{
            display: "flex",
            flex: "1",
            justifyContent: "center",
            alignItems: "stretch",
            // background: "yellow",
            flexDirection: "column",
            minHeight: "200px",
            marginInline: "20px",
            paddingBottom: "20px",
            // border: "solid 5px black",
          }}
        >
          <div
            style={{
              color: "#00ff00",
              margin: "10px 0 10px 0",
              textAlign: "center",
            }}
          >
            Uploading file ...
          </div>

          {fileDrop ? (
            Object.entries(fileDrop).map((e, i) => (
              <div style={{ flex: "1" }}>
                <div>
                  <span style={{ color: "yellow" }}>{i + 1 + ". "} </span>
                  <span>{e[1].name}</span>
                </div>

                <ProgressBar
                  style={{ width: "100%" }}
                  variant="info"
                  now={progress[i]}
                />
              </div>
            ))
          ) : (
            <></>
          )}

          {/* <Button
            onClick={() => {
              setAutoUpload({ show: false });
            }}
          >
            x
          </Button> */}
        </div>
      </ModalBodyBlack>
    </MyModal>
  );
}
